import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "#6E84A1",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4.583 3.086Q4 3.1 3.644 3.47q-.356.37-.384.954 0 .556.384.94t.94.384.954-.384q.397-.385.384-.94a1.4 1.4 0 0 0-.384-.954q-.37-.398-.955-.384" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M2.238 1.074q-.498.02-.832.352a1.1 1.1 0 0 0-.332.812v11.543q-.018.48.332.813t.832.332h11.543q.48 0 .813-.332.332-.333.332-.813V2.238a1.05 1.05 0 0 0-.332-.812 1.12 1.12 0 0 0-.813-.352Z" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M10.272 6.996a.9.9 0 0 0-.482.185 3 3 0 0 0-.55.535q-.275.335-.566.749a29 29 0 0 0-.55.812q-.26.397-.55.763a4.3 4.3 0 0 1-.52.566.85.85 0 0 1-.52.215q-.275 0-.795-.689a11 11 0 0 1-.23-.291q-.534-.72-.764-.872-.368-.245-.566.168-.108.245-.444 1.071t-.504 1.224v.306q0 .397.275.687a.84.84 0 0 0 .673.277h7.646q.397 0 .673-.277a.99.99 0 0 0 .29-.687v-.443q-.106-.215-.535-1.286a19 19 0 0 0-.765-1.713 7.6 7.6 0 0 0-.61-1.009q-.261-.274-.536-.29z" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }